// ExternalLink: opens in a new tab, secure by default (rel=noreferrer noopener),
// optionally renders a trailing arrow icon for affordance.
// Use everywhere external links are needed instead of writing <a target="_blank" rel="...">.

import type { ReactNode, CSSProperties } from 'react';
import { Icon } from './Icon';

export interface ExternalLinkProps {
  href: string;
  children: ReactNode;
  /** Show the up-right arrow icon after the label. Defaults to false. */
  withArrow?: boolean;
  /** Icon size when withArrow is true. */
  arrowSize?: number;
  className?: string;
  style?: CSSProperties;
  ariaLabel?: string;
}

export function ExternalLink({
  href,
  children,
  withArrow = false,
  arrowSize = 15,
  className,
  style,
  ariaLabel,
}: ExternalLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      className={className}
      style={style}
      aria-label={ariaLabel}
    >
      {children}
      {withArrow && <Icon name="arrow-up-right" size={arrowSize} />}
    </a>
  );
}
